/**
 * Custom Chart schema terms
 *
 * @package ext-components-pro
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const timePicker = {
	allowFreeform: {
		label: "schema:timePicker.allowFreeform#label",
		description: "schema:timePicker.allowFreeform#description"
	},
	increments: {
		label: "schema:timePicker.increments#label",
		description: "schema:timePicker.increments#description"
	},
	label: {
		label: "schema:timePicker.label#label",
		description: "schema:timePicker.label#description"
	},
	showSeconds: {
		label: "schema:timePicker.showSeconds#label",
		description: "schema:timePicker.showSeconds#description"
	},
	useHour12: {
		label: "schema:timePicker.useHour12#label",
		description: "schema:timePicker.useHour12#description"
	}
};
